import { Box, CircularProgress } from '@mui/material';
import React from 'react';
import { loadingStateStyles } from './styles';

const LoadingState: React.FC = () => (
  <Box sx={loadingStateStyles}>
    <CircularProgress size={40} />
  </Box>
);

LoadingState.displayName = 'LoadingState';

export default LoadingState;
